module.exports = __webpack_public_path__ + "assets/43b68fa8651f10654fea2dd55363a4fd.mp3";